import { getBuyButtonConfig } from '../utils/commonEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const GUSTO_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.gusto.buyBox.bulletPoint1' },
          { title: 'productPage.gusto.buyBox.bulletPoint2' },
          { title: 'productPage.gusto.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.gusto.buyBox.productName',
        productBadge: 'productPage.gusto.buyBox.badge',
        bulletPointsBoldWeight: 'bold',
        elevatedCard: true,
        interactService: {
          service: 'gusto_referral',
          openInNewTab: true,
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/man-standing-laptop.png',
      alt: 'productPage.gusto.heroHeaderPicture.altText',
    },
    headline: 'productPage.gusto.page.headline',
    partnerLogo: {
      src: '/s2/vector/logo-gusto-color.svg',
      alt: 'productPage.gusto.heroPartnerLogo.altText',
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.gusto.page.reviewText1',
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: 'productPage.gusto.page.trustpilotStarsAltText',
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: 'productPage.gusto.page.trustpilotLogoAltText',
      },
    ],
    subheader: 'productPage.gusto.page.subheader',
    subHeaderAlign: 'flex-end',
  },
  benefit: {
    title: 'productPage.gusto.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.gusto.valueProp.propTitle1',
        description: 'productPage.gusto.valueProp.shortCopy1',
        iconBgColor: 'background.green.main',
      },
      {
        icon: '/s2/material-icons/cachedrounded.svg',
        title: 'productPage.gusto.valueProp.propTitle2',
        description: 'productPage.gusto.valueProp.shortCopy2',
        iconBgColor: 'background.green.main',
      },
      {
        icon: '/s2/material-icons/factcheckrounded.svg',
        title: 'productPage.gusto.valueProp.propTitle3',
        description: 'productPage.gusto.valueProp.shortCopy3',
        iconBgColor: 'background.green.main',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.gusto.howItWorks.title',
    items: [
      {
        title: 'productPage.gusto.howItWorks.step1',
      },
      {
        title: 'productPage.gusto.howItWorks.step2',
      },
      {
        title: 'productPage.gusto.howItWorks.step3',
      },
      {
        title: 'productPage.gusto.howItWorks.step4',
      },
    ],
    image: '/s2/raster/gusto-product-expression.png',
    alt: 'productPage.gusto.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
    dividerBefore: true,
    scrollTopCta: {
      label: 'productPage.gusto.buyBox.buttonLabel',
    },
  },
  faqs: {
    title: 'productPage.gusto.frequentlyAskedQuestions.title',
    hideDividerBefore: true,
    disableItemGutters: true,
    items: [
      {
        question: 'productPage.gusto.frequentlyAskedQuestions.faq1',
        answer: 'productPage.gusto.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.gusto.frequentlyAskedQuestions.faq2',
        answer: 'productPage.gusto.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.gusto.frequentlyAskedQuestions.faq3',
        answer: 'productPage.gusto.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.gusto.frequentlyAskedQuestions.faq4',
        answer: 'productPage.gusto.frequentlyAskedQuestions.faqAnswer4',
      },
    ],
  },
  footnotes: {
    divider: false,
    items: [
      {
        text: 'productPage.gusto.footnotes.disclaimer1',
        link: 'https://gusto.com/legal/terms/promotional-terms',
        linkColor: 'info',
      },
    ],
  },
  assistance: {
    title: 'productPage.gusto.needAssistance.title',
    getInTouch: 'productPage.gusto.needAssistance.getInTouch',
    actions: 'productPage.gusto.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.gusto.buyBox.buttonLabel',
    }),
};
